import { encodingShared } from '@modules/encoding/shared';

export const FarmProfileContextualPanel = () => {
    return (
        <encodingShared.ContextualPanel>
            <encodingShared.ContextualPanel.Image background="/assets/images/farm.webp" />
        </encodingShared.ContextualPanel>
    );
};
